import classNames from "classnames";
import styles from "./index.module.scss";
import notImg from "@/assets/images/404.png";

const NotFound = () => {
	return (
		<div className={classNames(styles.notBox, "container")}>
			<img src={notImg} />
			<div>您访问的页面不在地球上，请返回火星吧~</div>
		</div>
	)
}

export default NotFound